import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const monitoringIssuesApi = {
    getMonitoringIssues: (): Observable<Dtos.GetMonitoringIssuesResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringIssues = new Dtos.GetMonitoringIssues();

        //Send request.
        const response: Promise<Dtos.GetMonitoringIssuesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitoringIssuesByMonitoringId: (monitoringId: number): Observable<Dtos.GetMonitoringIssuesByMonitoringIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringIssuesByMonitoringId = new Dtos.GetMonitoringIssuesByMonitoringId();

        request.monitoringId = monitoringId;

        //Send request.
        const response: Promise<Dtos.GetMonitoringIssuesByMonitoringIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitoringIssueById: (id: number): Observable<Dtos.GetMonitoringIssueByIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringIssueById = new Dtos.GetMonitoringIssueById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetMonitoringIssueByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setMonitoringIssue: (monitoringIssue: Dtos.MonitoringIssue): Observable<Dtos.SetMonitoringIssueResponse> => {

        let request: Dtos.SetMonitoringIssue = new Dtos.SetMonitoringIssue();

        request.monitoringIssue = monitoringIssue;

        // send request
        const response: Promise<Dtos.SetMonitoringIssueResponse> = client.post(request);

        return Observable.from(response);
    },
    createMonitoringIssue: (monitoringId: number): Observable<Dtos.CreateMonitoringIssueResponse> => {
        //Create the request.
        let request: Dtos.CreateMonitoringIssue = new Dtos.CreateMonitoringIssue();

        request.monitoringId = monitoringId;

        //Send request.
        const response: Promise<Dtos.CreateMonitoringIssueResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateMonitoringIssue: (monitoringIssue: Dtos.MonitoringIssue): Observable<Dtos.ValidateMonitoringIssueResponse> => {

        let request: Dtos.ValidateMonitoringIssue = new Dtos.ValidateMonitoringIssue();

        request.monitoringIssue = monitoringIssue;

        // send request
        const response: Promise<Dtos.ValidateMonitoringIssueResponse> = client.post(request);

        return Observable.from(response);
    }
}